export default "__VITE_ASSET__BcYCBbLK__"